var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{staticClass:"loader___U0gXU fullScreen___3stt8"},[_vm._m(0)]):_vm._e(),(!_vm.loading)?_c('cube-view',{attrs:{"parent":_vm.$route.meta.parent}}):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warpper___1_Ml1"},[_c('div',{staticClass:"inner___LZ9-r"}),_c('div',{staticClass:"text___27oz3"},[_vm._v("LOADING")])])
}]

export { render, staticRenderFns }